export const GET_POS_CUSTOMER_ID = '/Account/GetPOSByCustomerId';

export const GET_CRM_CUSTOMER = '/account/getcrmcustomer';
